module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/diogo/Documents/Projects/release-2022-04-07/metabase/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/diogo/Documents/Projects/release-2022-04-07/metabase/frontend/src/metabase/lib/ga-metadata.js"));
    });
  });
}